export const getVaccineCovid = (state) => {
    return state.vaccinationCovid
}